import FormErrorMessage from '@components/FormErrorMessage';
import PlacingOrderButtons from '@components/PlacingOrderButtons';
import PlacingOrderHeader from '@components/PlacingOrderHeader';
import { ButtonType } from '@components/Button';
import { Grid } from '@components/Grid';
import { IDisposalProcessingModalWindowProps } from '../types';
import { setReturnsType } from '@api/apiClient';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';

const DisposalProcessingModalWindow: React.FC<IDisposalProcessingModalWindowProps> = (props: IDisposalProcessingModalWindowProps): React.ReactElement => {
  const {
    handlerOnCloseDisposalProcessing,
    handlerRefreshData,
    selectedRowIds
  } = props;

  const { t } = useTranslation();

  const {
    error: errorSendDisposalOrder,
    isError: isErrorSendDisposalOrder,
    isLoading: isLoadingSendDisposalOrder,
    mutate: mutateSendDisposalOrder
  } = useMutation({
    mutationFn: setReturnsType,
    onSuccess() {
      handlerOnCloseDisposalProcessing();
      handlerRefreshData();
    }
  });

  return (
      <Grid>
        <PlacingOrderHeader
            description={`${t('disposalModalWindow.quantity')}: ${selectedRowIds.length}`}
            title={t('disposalModalWindow.description')}
        />
        <PlacingOrderButtons
            buttons={[
              {
                action: handlerOnCloseDisposalProcessing,
                disabled: isLoadingSendDisposalOrder,
                text: t('disposalModalWindow.no'),
                type: ButtonType.SKELETON
              }, {
                action: () => mutateSendDisposalOrder({
                  selectedAddressId: null,
                  returnType: 1,
                  comment: 'recycling',
                  deliveryInfo: null,
                  parcelIds: props.selectedRowIds
                }),
                disabled: isLoadingSendDisposalOrder,
                text: t('disposalModalWindow.yes'),
                type: ButtonType.BLOCK
              }
            ]}
        />
        {isErrorSendDisposalOrder && <FormErrorMessage error={errorSendDisposalOrder}/>}
      </Grid>
  );
};

export default DisposalProcessingModalWindow;